import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const canonicalUrl = "https://uniworktechnologies.com" + location.pathname;

  return (
    <div>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {children}
    </div>
  );
};

export default Layout;
